import { API_BASE_URL as BASE } from '@/lib/apiBase'
import { authFetch } from '@/lib/authFetch'
import { parseBuildIdentity, type BuildIdentity } from '@/lib/buildIdentity'

export const healthApi = {
  /**
   * The API's build identity. Only the dev image has one; every other
   * environment answers 404, which comes back as null rather than an error.
   */
  async version(): Promise<BuildIdentity | null> {
    const res = await authFetch(`${BASE}/v1/health/version`)
    if (!res.ok) return null
    return parseBuildIdentity(await res.json())
  },
}
